var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarlylearningcenterVectorLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 64,
    viewBox: "0 0 32 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6691 31.9954C12.6691 42.5049 21.0544 51.0547 31.5 51.3199V63.4961C14.334 63.229 0.5 49.2296 0.5 32C0.5 14.7704 14.334 0.771035 31.5 0.503888V12.6709C21.0544 12.936 12.6691 21.4858 12.6691 31.9954Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarlylearningcenterVectorLeft);
export default __webpack_public_path__ + "static/media/earlylearningcenter-vector-left.d35c6d53b8c51ec68b8661e55640e5f6.svg";
export { ForwardRef as ReactComponent };